/**
 * This file was auto-generated by client-types. Do not manually edit this file.
 * Your changes would be automatically overwritten.
 *
 * Service Documentation: https://private.hubteam.com/shoebill/service/com.hubspot.sensitive.data.status.controller.rpc.SensitiveDataStatusControllerFrontendService
 */

import type {
  ChirpAvroRpcDetails,
  Requestify,
  unhandledEnumCase,
  Default,
  HubspotMetadata,
} from 'rpc-client-utils';

export type CausalChainLink = {
  coordinates: ChirpMethodCoordinates;
  errorClass: string;
  errorMessage?: string;
};

export type ChirpMethodCoordinates = { service: string; method: string };

export type EmptyError = {
  chirpErrorMessage?: string;
  coordinates?: ChirpMethodCoordinates;
  causalChain: Default<CausalChainLink[]>;
  shouldRetry?: boolean;
};

export type SensitiveDataState =
  | 'DISABLED'
  | 'ONBOARDING_REQUESTED'
  | 'PROVISIONING'
  | 'ENABLED'
  | 'DECRYPT_ONLY'
  | 'SUBSETTINGS_UPDATED'
  | unhandledEnumCase;

export type BreezeAccessOptInType =
  | 'ENGAGEMENTS'
  | 'SENSITIVE_PROPERTIES'
  | unhandledEnumCase;

export type BreezeAccessOptInStatus = {
  optInType: BreezeAccessOptInType;
  optedIn: boolean;
};

export type GetBreezeAccessOptInResponse = {
  portalId: number;
  optedIn: boolean;
  optInType: BreezeAccessOptInType;
};

export type GetBreezeAccessOptInsResponse = {
  portalId: number;
  optIns: Default<BreezeAccessOptInStatus[]>;
};

export type GetHipaaEnabledForPortalResponse = {
  portalId: number;
  isHipaaEnabled: boolean;
};

export type GetMaskingOptInForPortalResponse = {
  portalId: number;
  optedIn: boolean;
};

export type GetPortalDisablementPermittedResponse = {
  reasons: Default<ToggleSensitiveDataErrorReason[]>;
  propertiesBlockingDisablement: Default<PropertyBlockingDisablement[]>;
  portalDisablementPermitted: Default<boolean>;
};

export type GetPortalEligibilityForSensitiveDataResponse = {
  portalId: number;
  isEligibleForSensitiveData: Default<boolean>;
};

export type GetSensitiveDataEnabledForPortalResponse = {
  portalId: number;
  sensitiveDataEnabled: boolean;
};

export type GetSensitiveDataStateForPortalResponse = {
  portalId: number;
  sensitiveDataState: SensitiveDataState;
  hasPortalExplicitlyDowngraded: Default<boolean>;
};

export type GetSensitiveDataSubsettingsForPortalResponse = {
  portalId: number;
  sensitiveDataSubsettings: Default<SDSCSensitiveDataValue[]>;
};

export type GetStateAndSubsettingsForPortalResponse = {
  portalId: number;
  sensitiveDataState: SensitiveDataState;
  sensitiveDataSubsettings: Default<SDSCSensitiveDataValue[]>;
};

export type PropertyBlockingDisablement = {
  propertyName: string;
  propertyLabel: string;
  objectTypeId: string;
  highlySensitive: boolean;
  personalHealthInfo: boolean;
  archived: Default<boolean>;
};

export type SetBreezeAccessOptInRequest = {
  optedIn: boolean;
  optInType: BreezeAccessOptInType;
};

export type ToggleSensitiveDataForPortalResponse = {};

export type ToggleSensitiveDataFrontendRequest = {
  sensitiveDataResponses: Default<SDSCSensitiveDataValue[]>;
};

export type UpdateMaskingOptInForPortalRequest = { optedIn: boolean };

export type UpdateSensitiveDataSubsettingsForPortalRequest = {
  subsettingsToUpdate: Default<SDSCSensitiveDataValue[]>;
};

export type UpdateSubsettingsForPortalAsyncResponse = {};

export type GetBreezeAccessOptInError = {
  errorType: GetBreezeAccessOptInErrorReason;
  chirpErrorMessage?: string;
  coordinates?: ChirpMethodCoordinates;
  causalChain: Default<CausalChainLink[]>;
  shouldRetry: Default<boolean>;
};

export type GetSensitiveDataEnabledForPortalError = {
  errorType: GetSensitiveDataEnabledErrorReason;
  chirpErrorMessage?: string;
  coordinates?: ChirpMethodCoordinates;
  causalChain: Default<CausalChainLink[]>;
  shouldRetry: Default<boolean>;
};

export type GetSensitiveDataStateForPortalError = {
  errorType: GetSensitiveDataStateErrorReason;
  chirpErrorMessage?: string;
  coordinates?: ChirpMethodCoordinates;
  causalChain: Default<CausalChainLink[]>;
  shouldRetry: Default<boolean>;
};

export type GetSensitiveDataSubsettingsForPortalError = {
  errorType: GetSensitiveDataSubsettingsForPortalErrorReason;
  chirpErrorMessage?: string;
  coordinates?: ChirpMethodCoordinates;
  causalChain: Default<CausalChainLink[]>;
  shouldRetry: Default<boolean>;
};

export type ToggleSensitiveDataError = {
  errorType: ToggleSensitiveDataErrorReason;
  chirpErrorMessage?: string;
  coordinates?: ChirpMethodCoordinates;
  causalChain: Default<CausalChainLink[]>;
  shouldRetry: Default<boolean>;
};

export type UpdateSensitiveDataSubsettingsError = {
  errorType: UpdateSensitiveDataSubsettingsErrorReason;
  chirpErrorMessage?: string;
  coordinates?: ChirpMethodCoordinates;
  causalChain: Default<CausalChainLink[]>;
  shouldRetry: Default<boolean>;
};

export type GetBreezeAccessOptInErrorReason =
  | 'PORTAL_NOT_FOUND'
  | 'PORTAL_NOT_IN_HUBLET'
  | 'PORTAL_GATED'
  | unhandledEnumCase;

export type GetSensitiveDataEnabledErrorReason =
  | 'PORTAL_NOT_FOUND'
  | 'PORTAL_NOT_IN_HUBLET'
  | unhandledEnumCase;

export type GetSensitiveDataStateErrorReason =
  | 'PORTAL_NOT_FOUND'
  | 'PORTAL_NOT_IN_HUBLET'
  | unhandledEnumCase;

export type GetSensitiveDataSubsettingsForPortalErrorReason =
  | 'PORTAL_NOT_FOUND'
  | 'PORTAL_NOT_IN_HUBLET'
  | unhandledEnumCase;

export type ToggleSensitiveDataErrorReason =
  | 'PORTAL_NOT_FOUND'
  | 'PORTAL_NOT_IN_HUBLET'
  | 'CANNOT_DISABLE_EXISTING_SENSITIVE_DATA_SUBSETTING'
  | 'CANNOT_ENABLE_SUBSETTING_WHEN_SENSITIVE_DATA_IS_DISABLED'
  | 'CANNOT_ENABLE_HIPAA_WITHOUT_HEALTH_SETTING_ENABLED'
  | 'INVALID_SENSITIVE_DATA_TYPE'
  | 'GDP_UPDATE_FAILED'
  | 'PORTAL_GATED_FOR_DISABLEMENT'
  | 'CANNOT_DISABLE_HIPAA_PORTAL'
  | 'CANNOT_DISABLE_WITH_HIGHLY_SENSITIVE_PROPERTIES'
  | 'CANNOT_DISABLE_HIPAA_WITH_PHI_PROPERTIES'
  | 'CANNOT_DISABLE_WITHOUT_RECENT_SCAN'
  | unhandledEnumCase;

export type UpdateSensitiveDataSubsettingsErrorReason =
  | 'PORTAL_NOT_FOUND'
  | 'PORTAL_NOT_IN_HUBLET'
  | 'CANNOT_DISABLE_EXISTING_SENSITIVE_DATA_SUBSETTING'
  | 'CANNOT_ENABLE_HIPAA_WITHOUT_HEALTH_SETTING_ENABLED'
  | 'PORTAL_ID_NOT_FOUND'
  | 'USER_ID_NOT_FOUND'
  | unhandledEnumCase;

export type SDSCSensitiveDataTypes =
  | 'PERSONAL_SENSITIVE_DATA'
  | 'FINANCIAL_DATA'
  | 'HEALTH_DATA'
  | 'HIPAA_COVERED_ENTITY'
  | unhandledEnumCase;

export type SDSCSensitiveDataValue = {
  sensitiveDataSetting: SDSCSensitiveDataTypes;
};

export type EnableSensitiveDataAsyncRequestType =
  Requestify<ToggleSensitiveDataFrontendRequest>;
export type EnableSensitiveDataAsyncResponseType =
  ToggleSensitiveDataForPortalResponse;
export type EnableSensitiveDataAsyncErrorType = ToggleSensitiveDataError &
  HubspotMetadata;
export const enableSensitiveDataAsyncRpc: ChirpAvroRpcDetails<
  EnableSensitiveDataAsyncRequestType,
  EnableSensitiveDataAsyncResponseType,
  EnableSensitiveDataAsyncErrorType,
  false
> = {
  serviceName:
    'com.hubspot.sensitive.data.status.controller.rpc.SensitiveDataStatusControllerFrontendService',
  rpcName: 'enableSensitiveDataAsync',
  auth: 'app',
  fingerprint: '1p0i2oQsSlLgeFnv_5AwVWS5DoaC4JFI',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false,
};

export type DisableSensitiveDataAsyncResponseType =
  ToggleSensitiveDataForPortalResponse;
export type DisableSensitiveDataAsyncErrorType = ToggleSensitiveDataError &
  HubspotMetadata;
export const disableSensitiveDataAsyncRpc: ChirpAvroRpcDetails<
  undefined,
  DisableSensitiveDataAsyncResponseType,
  DisableSensitiveDataAsyncErrorType,
  false
> = {
  serviceName:
    'com.hubspot.sensitive.data.status.controller.rpc.SensitiveDataStatusControllerFrontendService',
  rpcName: 'disableSensitiveDataAsync',
  auth: 'app',
  fingerprint: 'AAAAAAAAAADgeFnv_5AwVWS5DoaC4JFI',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false,
};

export type GetSensitiveDataOnboardingOrEnabledResponseType =
  GetSensitiveDataEnabledForPortalResponse;
export type GetSensitiveDataOnboardingOrEnabledErrorType =
  GetSensitiveDataEnabledForPortalError & HubspotMetadata;
export const getSensitiveDataOnboardingOrEnabledRpc: ChirpAvroRpcDetails<
  undefined,
  GetSensitiveDataOnboardingOrEnabledResponseType,
  GetSensitiveDataOnboardingOrEnabledErrorType,
  false
> = {
  serviceName:
    'com.hubspot.sensitive.data.status.controller.rpc.SensitiveDataStatusControllerFrontendService',
  rpcName: 'getSensitiveDataOnboardingOrEnabled',
  auth: 'app',
  fingerprint: 'AAAAAAAAAACxAVQQlE1SAEmI1ATOYKph',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false,
};

export type GetSensitiveDataSubsettingsResponseType =
  GetSensitiveDataSubsettingsForPortalResponse;
export type GetSensitiveDataSubsettingsErrorType =
  GetSensitiveDataSubsettingsForPortalError & HubspotMetadata;
export const getSensitiveDataSubsettingsRpc: ChirpAvroRpcDetails<
  undefined,
  GetSensitiveDataSubsettingsResponseType,
  GetSensitiveDataSubsettingsErrorType,
  false
> = {
  serviceName:
    'com.hubspot.sensitive.data.status.controller.rpc.SensitiveDataStatusControllerFrontendService',
  rpcName: 'getSensitiveDataSubsettings',
  auth: 'app',
  fingerprint: 'AAAAAAAAAAD2H1fq9vE1neJ9y0dcNOkN',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false,
};

export type GetHipaaEnabledForPortalResponseType =
  GetHipaaEnabledForPortalResponse;
export type GetHipaaEnabledForPortalErrorType = EmptyError & HubspotMetadata;
export const getHipaaEnabledForPortalRpc: ChirpAvroRpcDetails<
  undefined,
  GetHipaaEnabledForPortalResponseType,
  GetHipaaEnabledForPortalErrorType,
  false
> = {
  serviceName:
    'com.hubspot.sensitive.data.status.controller.rpc.SensitiveDataStatusControllerFrontendService',
  rpcName: 'getHipaaEnabledForPortal',
  auth: 'app',
  fingerprint: 'AAAAAAAAAAAl0Bt4jgnZM5wP6LXzGzX8',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false,
};

export type UpdateSubsettingsAsyncRequestType =
  Requestify<UpdateSensitiveDataSubsettingsForPortalRequest>;
export type UpdateSubsettingsAsyncResponseType =
  UpdateSubsettingsForPortalAsyncResponse;
export type UpdateSubsettingsAsyncErrorType =
  UpdateSensitiveDataSubsettingsError & HubspotMetadata;
export const updateSubsettingsAsyncRpc: ChirpAvroRpcDetails<
  UpdateSubsettingsAsyncRequestType,
  UpdateSubsettingsAsyncResponseType,
  UpdateSubsettingsAsyncErrorType,
  false
> = {
  serviceName:
    'com.hubspot.sensitive.data.status.controller.rpc.SensitiveDataStatusControllerFrontendService',
  rpcName: 'updateSubsettingsAsync',
  auth: 'app',
  fingerprint: 'D3ps9tIOdxh1A4yIN-yisG-h3FFx0iPM',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false,
};

export type GetSensitiveDataStateAndSubsettingsForPortalResponseType =
  GetStateAndSubsettingsForPortalResponse;
export type GetSensitiveDataStateAndSubsettingsForPortalErrorType = EmptyError &
  HubspotMetadata;
export const getSensitiveDataStateAndSubsettingsForPortalRpc: ChirpAvroRpcDetails<
  undefined,
  GetSensitiveDataStateAndSubsettingsForPortalResponseType,
  GetSensitiveDataStateAndSubsettingsForPortalErrorType,
  false
> = {
  serviceName:
    'com.hubspot.sensitive.data.status.controller.rpc.SensitiveDataStatusControllerFrontendService',
  rpcName: 'getSensitiveDataStateAndSubsettingsForPortal',
  auth: 'app',
  fingerprint: 'AAAAAAAAAAALH_DkCygQcpwP6LXzGzX8',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false,
};

export type GetSensitiveDataStateForPortalResponseType =
  GetSensitiveDataStateForPortalResponse;
export type GetSensitiveDataStateForPortalErrorType =
  GetSensitiveDataStateForPortalError & HubspotMetadata;
export const getSensitiveDataStateForPortalRpc: ChirpAvroRpcDetails<
  undefined,
  GetSensitiveDataStateForPortalResponseType,
  GetSensitiveDataStateForPortalErrorType,
  false
> = {
  serviceName:
    'com.hubspot.sensitive.data.status.controller.rpc.SensitiveDataStatusControllerFrontendService',
  rpcName: 'getSensitiveDataStateForPortal',
  auth: 'app',
  fingerprint: 'AAAAAAAAAABHZ1tQIxw1HWX85kvNcO5P',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false,
};

export type GetPortalDisablementPermittedResponseType =
  GetPortalDisablementPermittedResponse;
export type GetPortalDisablementPermittedErrorType = EmptyError &
  HubspotMetadata;
export const getPortalDisablementPermittedRpc: ChirpAvroRpcDetails<
  undefined,
  GetPortalDisablementPermittedResponseType,
  GetPortalDisablementPermittedErrorType,
  false
> = {
  serviceName:
    'com.hubspot.sensitive.data.status.controller.rpc.SensitiveDataStatusControllerFrontendService',
  rpcName: 'getPortalDisablementPermitted',
  auth: 'app',
  fingerprint: 'AAAAAAAAAACJh5pZbMMkupwP6LXzGzX8',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false,
};

export type GetPortalEligibilityForSensitiveDataResponseType =
  GetPortalEligibilityForSensitiveDataResponse;
export type GetPortalEligibilityForSensitiveDataErrorType = EmptyError &
  HubspotMetadata;
export const getPortalEligibilityForSensitiveDataRpc: ChirpAvroRpcDetails<
  undefined,
  GetPortalEligibilityForSensitiveDataResponseType,
  GetPortalEligibilityForSensitiveDataErrorType,
  false
> = {
  serviceName:
    'com.hubspot.sensitive.data.status.controller.rpc.SensitiveDataStatusControllerFrontendService',
  rpcName: 'getPortalEligibilityForSensitiveData',
  auth: 'app',
  fingerprint: 'AAAAAAAAAABNTFOCHSOKmpwP6LXzGzX8',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false,
};

export type GetMaskingOptInResponseType = GetMaskingOptInForPortalResponse;
export type GetMaskingOptInErrorType = EmptyError & HubspotMetadata;
export const getMaskingOptInRpc: ChirpAvroRpcDetails<
  undefined,
  GetMaskingOptInResponseType,
  GetMaskingOptInErrorType,
  false
> = {
  serviceName:
    'com.hubspot.sensitive.data.status.controller.rpc.SensitiveDataStatusControllerFrontendService',
  rpcName: 'getMaskingOptIn',
  auth: 'app',
  fingerprint: 'AAAAAAAAAABIalFj0WOogZwP6LXzGzX8',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false,
};

export type SetMaskingOptInRequestType =
  Requestify<UpdateMaskingOptInForPortalRequest>;
export type SetMaskingOptInResponseType = GetMaskingOptInForPortalResponse;
export type SetMaskingOptInErrorType = EmptyError & HubspotMetadata;
export const setMaskingOptInRpc: ChirpAvroRpcDetails<
  SetMaskingOptInRequestType,
  SetMaskingOptInResponseType,
  SetMaskingOptInErrorType,
  false
> = {
  serviceName:
    'com.hubspot.sensitive.data.status.controller.rpc.SensitiveDataStatusControllerFrontendService',
  rpcName: 'setMaskingOptIn',
  auth: 'app',
  fingerprint: '3jpyaZ_vw8dIalFj0WOogZwP6LXzGzX8',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false,
};

export type GetBreezeAccessOptInsResponseType = GetBreezeAccessOptInsResponse;
export type GetBreezeAccessOptInsErrorType = GetBreezeAccessOptInError &
  HubspotMetadata;
export const getBreezeAccessOptInsRpc: ChirpAvroRpcDetails<
  undefined,
  GetBreezeAccessOptInsResponseType,
  GetBreezeAccessOptInsErrorType,
  false
> = {
  serviceName:
    'com.hubspot.sensitive.data.status.controller.rpc.SensitiveDataStatusControllerFrontendService',
  rpcName: 'getBreezeAccessOptIns',
  auth: 'app',
  fingerprint: 'AAAAAAAAAACRezYBNLdy8UfYJ6S_vksz',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false,
};

export type SetBreezeAccessOptInRequestType =
  Requestify<SetBreezeAccessOptInRequest>;
export type SetBreezeAccessOptInResponseType = GetBreezeAccessOptInResponse;
export type SetBreezeAccessOptInErrorType = GetBreezeAccessOptInError &
  HubspotMetadata;
export const setBreezeAccessOptInRpc: ChirpAvroRpcDetails<
  SetBreezeAccessOptInRequestType,
  SetBreezeAccessOptInResponseType,
  SetBreezeAccessOptInErrorType,
  false
> = {
  serviceName:
    'com.hubspot.sensitive.data.status.controller.rpc.SensitiveDataStatusControllerFrontendService',
  rpcName: 'setBreezeAccessOptIn',
  auth: 'app',
  fingerprint: 'gCEoYvrlG8al5O-fTElgwkfYJ6S_vksz',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false,
};
